const aaa = [
	{
		path: "good",
		component: () => import("@/views/shuju/good/list.vue"),
		meta:{title:'商品数据'},
	},
]
export default aaa;